import React from 'react';
import { randomString } from '@togglecorp/fujs';
import AlertContext, { DEFAULT_ALERT_DISMISS_DURATION } from '../components/AlertContext.js';

function useAlert() {
  const {
    addAlert,
    removeAlert,
    updateAlertContent
  } = React.useContext(AlertContext);
  const show = React.useCallback((children, options) => {
    const name = (options === null || options === void 0 ? void 0 : options.name) ?? randomString(16);
    addAlert({
      variant: (options === null || options === void 0 ? void 0 : options.variant) ?? 'info',
      duration: (options === null || options === void 0 ? void 0 : options.duration) ?? DEFAULT_ALERT_DISMISS_DURATION,
      name,
      children,
      nonDismissable: (options === null || options === void 0 ? void 0 : options.nonDismissable) ?? false
    });
  }, [addAlert]);
  const hide = removeAlert;
  const updateContent = updateAlertContent;
  const alert = React.useMemo(() => ({
    show,
    hide,
    updateContent
  }), [show, hide, updateContent]);
  return alert;
}

export { useAlert as default };
//# sourceMappingURL=useAlert.js.map
